module.exports = __webpack_public_path__ + "img/product_xd_4.3b8fb257.jpg";